<template>
  <div class="material">
    <div class="header-tool" style="min-height: 100px;">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>管理</BreadcrumbItem>
          <BreadcrumbItem>证件申请</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">证件申请</div>
      </div>
    </div>

    <div class="display">
       <div id="qrcodeShare" ref="qrCodeUrl"></div>
        <Button  @click="downLoad()" style="margin-top: 20px">下载二维码</Button>
        <div>
         <Button  @click="copyUrl()" style="margin-top: 20px">复制导入链接</Button>
        </div>
       
      <!-- <div v-if="info && info.length">
        <div v-for="(item, index) in info" :key="'contact-' + index">
          <div class="item">
            <div class="item-l">提交时间：</div>
            <div class="item-r" v-if="item.deExCardDown">{{ item.deExCardDown.inTime | moment("YYYY/MM/DD HH:mm:ss")}}</div>
          </div>
          <div class="item">
            <div class="item-l">审核状态：</div>
            <div class="item-r">
              <span v-if="item.status === 0" style="color: red;">尚未审核</span>
              <span v-if="item.status === 1" style="color: blue;">审核通过</span>
              <span v-if="item.status === -1" style="color: red;">审核未通过</span>
            </div>
          </div>
          <div class="item">
            <div class="item-l">操作状态：</div>
            <div class="item-r" v-if="item.deExCardDown">
              <span style="margin-right: 10px;color: #1890ff;" v-if="item.deExCardDown.commandId === 1">新增</span>
              <span style="margin-right: 10px;" v-if="item.deExCardDown.commandId === 2">修改</span>
              <span style="margin-right: 10px;color: #f00;" v-if="item.deExCardDown.commandId === 3">删除</span>
            </div>
          </div>
          <div class="item">
            <div class="item-l">胸卡类型：</div>
            <div class="item-r">展商证</div>
          </div>
          <div class="item" v-if="item.deExCardDown">
            <div class="item-l">公司名称：</div>
            <div class="item-r">{{item.deExCardDown.companyName}}</div>
          </div>
          <div class="item" v-if="item.deExCardDown">
            <div class="item-l">姓名：</div>
            <div
              class="item-r"
              :class="{editMode:  (!item.deExCardUp || item.deExCardUp.firstName !== item.deExCardDown.firstName)}"
            >{{ item.deExCardDown.firstName || 'N/A'}}</div>
          </div>
          <div class="item" v-if="item.deExCardDown">
            <div class="item-l">身份证号：</div>
            <div
              class="item-r"
              :class="{editMode:  (!item.deExCardUp || item.deExCardUp.idCard !== item.deExCardDown.idCard)}"
            >{{ item.deExCardDown.idCard || 'N/A'}}</div>
          </div>
          <div class="item" v-if="item.deExCardDown">
            <div class="item-l">电话：</div>
            <div
              class="item-r"
              :class="{editMode:  (!item.deExCardUp || item.deExCardUp.tel !== item.deExCardDown.tel)}"
            >{{ item.deExCardDown.tel || 'N/A'}}</div>
          </div>
          <div class="item" v-if="item.deExCardDown">
            <div class="item-l">邮箱：</div>
            <div
              class="item-r"
              :class="{editMode:  (!item.deExCardUp || item.deExCardUp.email !== item.deExCardDown.email)}"
            >{{ item.deExCardDown.email || 'N/A'}}</div>
          </div>
          <div class="item" v-if="item.deExCardDown">
            <div class="item-l">职务：</div>
            <div
              class="item-r"
              :class="{editMode:  (!item.deExCardUp || item.deExCardUp.jobTitle !== item.deExCardDown.jobTitle)}"
            >{{ item.deExCardDown.jobTitle || 'N/A'}}</div>
          </div>
          <div class="f-tac" v-if="item && item.status === 0">
            <Button @click="pass(item)" style="margin: 0 10px;" type="primary">通过审核</Button>
            <Button @click="unpass(item)" style="margin: 0 10px;" type="primary">不通过</Button>
          </div>
          <div class="line"></div>
        </div>
      </div>
      <div v-else style="line-height:500px;text-align:center;">暂无数据！</div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import QRCode from "qrcodejs2";
export default {
  name: "host-audit-info",
  data() {
    return {
      info: [1,1],
      shareUrl:"",
      shareImportUrl:""
    };
  },
  components: {
  },
  computed: {
    ...mapGetters({
      exhibitionInfo: "hostSetModule/getHostExhibition"
    })
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getApplyCert: "hostCommonModule/getApplyCert",
      auditApplyCert: "hostCommonModule/auditApplyCert",
      getShareUrl:"hostActModule/getShareUrl"
    }),
    async init() {
      let list = await this.getApplyCert(this.exhibitionInfo.id);
      this.info = list;
      this.getUrl()
    },
    async getUrl(){
      console.log(this.exhibitionInfo);
      let opt={
        "ExhibitionId":this.exhibitionInfo.id
      }
      let data=await this.getShareUrl(opt)
      console.log(data,'返回的数据');
      if(data){
        this.shareUrl=data.shareUrl,
        this.shareImportUrl=data.shareImportUrl
        this.getQrCode()
      }
      
    },
    getQrCode() {
      this.$refs.qrCodeUrl.innerHTML = "";
      // this.url = location.href;
      let qrcode = new QRCode("qrcodeShare", {
        width: 130,
        height: 130,
        text: this.shareUrl, // 二维码内容
        correctLevel: 3,
      });
    },
    downLoad(){
      /* alert("下载"); */
      console.log('666');
			let canvas = $("#qrcodeShare").find("canvas").get(0); 
			this.downLoadImage(canvas);
    },
    copyUrl(){
        this.$Message.success('复制成功')
        const input = document.createElement('input')
        document.body.appendChild(input)
        input.setAttribute('value',this.shareImportUrl)
        input.select()
        if (document.execCommand('copy')) {
          document.execCommand('copy')
        }
        document.body.removeChild(input)
    },
		//被调用的方法
		downLoadImage(canvas) {
			var a = document.createElement("a");
			a.href = canvas.toDataURL();
			a.download = '二维码';
			a.click();
		},
    async pass(item) {
      // 通过审核
      const opt = {
        id: item.recordId,
        status: 1
      };
      const bool = await this.auditApplyCert(opt);
      if (bool && bool.successed) {
        this.$Message.success("操作成功");
        this.init();
      } else {
        if (bool.errors.description) {
          this.$Message.error(bool.errors.description);
        } else {
          this.$Message.error("操作失败，请重新尝试");
        }
      }
    },
    async unpass(item) {
      // 不通过审核
      const opt = {
        id: item.recordId,
        status: -1
      };
      const bool = await this.auditApplyCert(opt);
      if (bool && bool.successed) {
        this.$Message.success("操作成功");
        this.init();
      } else {
        if (bool.errors.description) {
          this.$Message.error(bool.errors.description);
        } else {
          this.$Message.error("操作失败，请重新尝试");
        }
      }
    },
  }
};
</script>

<style scoped lang="scss">
.display {
  padding: 20px 40px 40px;
  font-size: 14px;
  background: #fff;
  margin: 30px;
  color: #333;
  min-width: 800px;
  min-height: 500px;
  .item {
    display: flex;
    margin-bottom: 18px;
    &-l {
      width: 200px;
      text-align: right;
    }
    &-r {
      flex: 1;
    }
  }
}
.editMode {
  color: red !important;
}
.edit {
  border-color: red !important;
}
.line {
  height: 1px;
  background: #ccc;
  margin: 20px 0;
}
</style>

